import type { HttpClient } from '@remodeling/base';
import querystring from 'query-string';
import {
  GetConstructionCaseCheckCounselorResponse,
  GetConstructionCaseListRequest,
  GetConstructionCaseListResponse,
} from '../../model';

export class GetConstructionCaseListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetConstructionCaseListRequest) {
    const query = querystring.stringify(req);
    return await this.httpClient.request<GetConstructionCaseListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/constructCase?${query}`,
    });
  }
}

/**
 * 전문가 콘텐츠를 파악하는 API
 */
export class GetConstructCaseCheckCounselor {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetConstructionCaseCheckCounselorResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/constructCase/checkCounselor/`,
      },
    );
  }
}
